import axios from './api';

/**
 * Upload a photo file for a newly created lawyer
 */
export const uploadPhotoForLawyer = async (
  lawyerId: string, 
  file: File
): Promise<{ success: boolean; photoUrl?: string; error?: string }> => {
  try {
    const formData = new FormData();
    formData.append('photo', file);

    const response = await axios.post(
      `/api/photos/${lawyerId}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    if (response.data.success) {
      return {
        success: true,
        photoUrl: response.data.lawyer.profilePhotoUrl
      };
    } else {
      return {
        success: false,
        error: response.data.error || 'Upload failed'
      };
    }
  } catch (error: any) {
    console.error('Photo upload error:', error);
    return {
      success: false,
      error: error.response?.data?.error || 'Failed to upload photo'
    };
  }
};

/**
 * Convert blob URL to File object (for re-uploading)
 */
export const blobUrlToFile = async (blobUrl: string, fileName: string): Promise<File | null> => {
  try {
    const response = await fetch(blobUrl);
    const blob = await response.blob();
    return new File([blob], fileName, { type: blob.type });
  } catch (error) {
    console.error('Error converting blob URL to file:', error);
    return null;
  }
};

